import objectKeysToCamelCase from '@grebban/utils/object/keysToCamelCase';

const camelCaseOptions = { recursive: true, modifyInputObject: false };

/**
 * Returns a new object with the same keys as raw, and each value camelCased (if it is an object).
 * Use for maps where keys must stay unchanged (e.g. IDs, UUIDs)
 * and only nested shape should be normalised (references, media, etc.).
 *
 * @param raw - Source object.
 * @returns New object: same keys as raw, object values camelCased.
 */
export function camelCaseMapValues(raw: Record<string, unknown> | null | undefined): Record<string, unknown> {
    const source = raw ?? {};
    const out: Record<string, unknown> = {};
    for (const [id, value] of Object.entries(source)) {
        out[id] =
            value != null && typeof value === 'object'
                ? objectKeysToCamelCase(value as Record<string, unknown>, camelCaseOptions)
                : value;
    }
    return out;
}
